// import pinApi from '../config';

import api from '../module/payment-panel/shared/service/config'
export default async function postPin(path, options) {
    const response = await fetch(`${api}/identity-provider-admin/api/v1` + path, options);
    const result = await response.json();

    return result;
}
